import { NmDatatableCommonSettings } from './datatable.interface';
import { environment } from '../../environments/environment';

declare let bootbox: any;

/**
* Configuration for datatable 
* default settings for ALL datatable component
* will be override by input [settings] of the component
*/
export const commonSettings: NmDatatableCommonSettings = {

	// before ajax send callback
	ajaxBeforeSend: function(xhr, settings): void {
		// set headers
		xhr.setRequestHeader('Authorization', `BEARER ${localStorage.getItem('jwt')}`);
	},

	// after ajax send callback
	// ajaxAfterSend: function(xhr, status): void {},

	// default global url massage
	ajaxUrlMassage: function(endpoint: string): string {
		return environment.getApiPath(endpoint);
	},

	// data massage
	// ajaxDataMassage: function(data: any[]) {
	// 	return data;
	// },
	
	// action button callback
	actionButtonCallback: {
		edit: function(id: string, data: any): void {
			let url = this.router.url + `/edit/${id}`;
			this.router.navigate([url]);
		},
		delete: function(id: string, data: any): void {
			bootbox.confirm('Are you sure?', (ok) => {
				if(ok) {
					this.dataService[this.settings.modelName].delete(id)
					.then(() => this.reload());
				}
			});
		},
		view: function(id: string, data: any): void {
			let url = this.router.url.split('/').slice(0,-1).concat(['view', id]).join('/');
			this.router.navigate([url]);
		}
	}
};


// WEBPACK FOOTER //
// ./src/widgets/datatable/datatable.config.ts